"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DigitalSignature = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var common_1 = require("../common");
var locales_1 = require("../resources/locales");
var react_intl_1 = require("react-intl");
var DigitalSignatureButton_1 = require("./DigitalSignatureButton");
var mobx_react_1 = require("mobx-react");
var GlobalStyles_1 = require("../GlobalStyles");
var CryptoContext_1 = require("../context/CryptoContext");
var defineTheme = function (outerTheme) {
    var _a;
    var theme = __assign({}, outerTheme);
    if ((_a = outerTheme.variables) === null || _a === void 0 ? void 0 : _a.palette.crypto) {
        return core_1.createMuiTheme(outerTheme);
    }
    theme.variables.palette && (theme.variables.palette.crypto = common_1.defaultTheme);
    return core_1.createMuiTheme(theme);
};
exports.DigitalSignature = mobx_react_1.observer(function (props) {
    var _a = props.locale, locale = _a === void 0 ? common_1.defaultLocale : _a, _b = props.isView, isView = _b === void 0 ? false : _b, signatureStatus = props.signatureStatus, signatureSetting = props.signatureSetting, fileDownloadComponent = props.fileDownloadComponent, cryptoContextProps = __rest(props, ["locale", "isView", "signatureStatus", "signatureSetting", "fileDownloadComponent"]);
    if (!signatureSetting.signatureEnabled ||
        (!signatureSetting.signatureBrowserPlugin && !signatureSetting.signatureUpload)) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(GlobalStyles_1.GlobalStyles, null),
        react_1.default.createElement(styles_1.ThemeProvider, { theme: defineTheme },
            react_1.default.createElement(react_intl_1.IntlProvider, { locale: locale, messages: locales_1.translations[locale] },
                react_1.default.createElement(CryptoContext_1.CryptoContext.Provider, { value: __assign({ signatureSetting: signatureSetting }, cryptoContextProps) },
                    react_1.default.createElement(DigitalSignatureButton_1.DigitalSignatureButton, { isView: isView, fileDownloadComponent: fileDownloadComponent, signatureStatus: signatureStatus }))))));
});
